export default __webpack_public_path__ + "static/media/forward-ten_1.9712f6b6.png";